export const USER_GROUP_COLUMNS = [
  {
    Header: "Group Id",
    accessor: "GroupId"
  },
  {
    Header: "Name",
    accessor: "Name"
  },
  {
    Header: "Description",
    accessor: "Description"
  }
];
